<template>
  <div class="form-group" id="company-name-group">
    <label for="company-name">Nome da Empresa</label>
    <input type="text" class="form-control" id="company-name" placeholder="Digite o nome da empresa">
</div>
<div class="form-group" id="company-tagline-group">
    <label for="company-tagline">Slogan (Opcional)</label>
    <input type="text" class="form-control" id="company-tagline" placeholder="Uma frase curta sobre a empresa">
</div>
<div class="form-group" id="company-description-group">
    <label for="company-description">Descrição (Opcional)</label>
    <div class="textarea form-control" id="company-description"></div>
</div>
<div class="form-group" id="company-video-group">
    <label for="company-video">Vídeo (Opcional)</label>
    <input type="text" class="form-control" id="company-video" placeholder="URL do vídeo">
</div>
<div class="form-group" id="company-website-group">
    <label for="company-website">Site (Opcional)</label>
    <input type="text" class="form-control" id="company-website" placeholder="http://">
</div>
<div class="form-group" id="company-instagram-group">
    <label for="company-instagram">Usuário do Instagram (Opcional)</label>
    <input type="text" class="form-control" id="company-instagram" placeholder="suaempresa">
</div>
<div class="form-group" id="company-facebook-group">
    <label for="company-facebook">Usuário do Facebook (Opcional)</label>
    <input type="text" class="form-control" id="company-facebook" placeholder="suaempresa">
</div>
<div class="form-group" id="company-linkedin-group">
    <label for="company-linkedin">Usuário do LinkedIn (Opcional)</label>
    <input type="text" class="form-control" id="company-linkedin" placeholder="suaempresa">
</div>
<div class="form-group" id="company-twitter-group">
    <label for="company-twitter">Usuário do Twitter (Opcional)</label>
    <input type="text" class="form-control" id="company-twitter" placeholder="@suaempresa">
</div>
<div class="form-group" id="company-logo-group">
    <label for="company-logo">Logo (Opcional)</label>
    <input type="file" id="company-logo">
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>